module.exports = __webpack_public_path__ + "static/media/nft-CuteBunny.3bea0d9d.png";